<span class="pull-right search-button-container">
  <button
    mat-stroked-button
    class="search-button"
    [matMenuTriggerFor]="moreFiltersMenu"
  >
    <mat-icon class="me-2">filter_alt</mat-icon> More Filters
  </button>

  @if (moreFilterCount() > 0) {
    <span class="filter-counter">{{ moreFilterCount() }}</span>
  }
</span>

<mat-menu #moreFiltersMenu="matMenu" direction="down" yPosition="below">
  @for (filter of moreFilters; track filter.fieldVar) {
    <app-simple-chip-filter
      [label]="filter.label"
      [fieldVar]="filter.fieldVar"
      [value]="filter.value"
      (toggleFiltersUpdated)="toggleFiltersUpdated($event)"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    />
  }
</mat-menu>

<div class="toolbar mb-2 pt-2">
  @if (viewMode === 'ho' || viewMode === 'carrier') {
    <span>
      <mat-form-field>
        <mat-label>Unit</mat-label>
        <input
          type="text"
          matInput
          placeholder="Select a Unit"
          [matAutocomplete]="unitAuto"
          [formControl]="unitCtrl"
        />
        <mat-autocomplete
          #unitAuto="matAutocomplete"
          (optionSelected)="selectUnit($event)"
        >
          @if (filteredUnits.length > 0) {
            @for (unit of filteredUnits; track unit.id) {
              <mat-option [value]="unit.id">
                {{ unit.id }}: {{ unit.name }}
              </mat-option>
            }
          }
        </mat-autocomplete>
      </mat-form-field>
    </span>
  }
  @if (
    filteredUnits &&
    filteredUnits.length > 0 &&
    (viewMode === 'ho' || viewMode === 'carrier')
  ) {
    <span>
      <mat-form-field>
        <mat-label>User Hierarchy</mat-label>
        <input
          type="text"
          placeholder="Select a user..."
          matInput
          [matAutocomplete]="autoUserStandalone"
          [formControl]="userControlStandalone"
        />
        <mat-autocomplete
          #autoUserStandalone="matAutocomplete"
          [displayWith]="displayUser"
          (optionSelected)="changeUserStandalone($event)"
        >
          @if (dropdownLoadingStandalone) {
            <mat-option disabled class="dropdownLoadingSpinner">
              <mat-spinner diameter="48" />
            </mat-option>
          }
          @if (
            !dropdownLoadingStandalone &&
            dropdownNoResultsStandalone &&
            userControlStandalone.value
          ) {
            <mat-option disabled>No Results</mat-option>
          }
          @if (
            !dropdownLoadingStandalone &&
            !userControlStandalone.value &&
            filteredUsersStandalone.length === 0
          ) {
            <mat-option disabled>Enter a value to search</mat-option>
          }
          @if (!dropdownLoadingStandalone && !dropdownNoResultsStandalone) {
            @for (opt of filteredUsersStandalone; track opt.value) {
              <mat-option class="custom-select-option" [value]="opt">
                {{ opt.name }}
              </mat-option>
            }
          }
        </mat-autocomplete>
        @if (userControlStandalone.value) {
          <button
            matSuffix
            matIconButton
            aria-label="Clear"
            color="warn"
            type="button"
            matTooltip="Clear User Search"
            (click)="clearUserStandalone()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </span>
  }
  @if (viewMode === 'ho' || viewMode === 'carrier') {
    <span>
      <mat-form-field>
        <mat-label>User (For NPN Search)</mat-label>
        <input
          type="text"
          placeholder="Select a user..."
          matInput
          [matAutocomplete]="autoUser"
          [formControl]="userControl"
        />
        <mat-autocomplete
          #autoUser="matAutocomplete"
          [displayWith]="displayUser"
          (optionSelected)="changeSelection($event)"
        >
          @if (dropdownLoading) {
            <mat-option disabled class="dropdownLoadingSpinner">
              <mat-spinner diameter="48" />
            </mat-option>
          }
          @if (!dropdownLoading && dropdownNoResults && userControl.value) {
            <mat-option disabled>No Results</mat-option>
          }
          @if (
            !dropdownLoading && !userControl.value && filteredUsers.length === 0
          ) {
            <mat-option disabled>Enter a value to search</mat-option>
          }
          @if (!dropdownLoading && !dropdownNoResults) {
            @for (opt of filteredUsers; track opt.value) {
              <mat-option class="custom-select-option" [value]="opt">
                {{ opt.name }}
              </mat-option>
            }
          }
        </mat-autocomplete>
        @if (userControl.value) {
          <button
            matSuffix
            matIconButton
            aria-label="Clear"
            color="warn"
            type="button"
            matTooltip="Clear User Search"
            (click)="clearRepSearch()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </span>
  }

  <mat-form-field class="">
    <mat-label>
      {{
        viewMode === 'ho' || viewMode === 'carrier'
          ? "User's Associated NPNs"
          : 'User Search (Name - NPN)'
      }}
    </mat-label>
    <mat-chip-grid
      #chipGrid
      aria-label="NPN"
      [disabled]="
        (!userControl.value || chipOptions().length <= 0 || fetchingNpns) &&
        (viewMode === 'ho' || viewMode === 'carrier')
      "
    >
      @for (chip of chips(); track $index) {
        <mat-chip-row (removed)="removeNpn(chip)">
          {{ chipDisplay(chip) }}
          <button matChipRemove [attr.aria-label]="'remove ' + chip">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      #chipInput
      name="currentChip"
      placeholder="Select NPN..."
      [value]="currentChip()"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="chipAuto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [disabled]="
        !userControl.value && (viewMode === 'ho' || viewMode === 'carrier')
      "
      [(ngModel)]="currentChip"
    />
    <mat-autocomplete
      #chipAuto="matAutocomplete"
      [disabled]="
        (!userControl.value || chipOptions().length <= 0 || fetchingNpns) &&
        (viewMode === 'ho' || viewMode === 'carrier')
      "
      (optionSelected)="npnSelected($event)"
    >
      @for (chip of filteredChips(); track chip) {
        <mat-option [value]="chip.NPN">
          {{ chip.Name }} - {{ chip.NPN }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (!userControl.value && (viewMode === 'ho' || viewMode === 'carrier')) {
      <mat-hint>Select a user to enable</mat-hint>
    } @else if (fetchingNpns) {
      <mat-hint>Retrieving associated NPNs</mat-hint>
    } @else if (
      userControl.value &&
      chipOptions().length <= 0 &&
      (viewMode === 'ho' || viewMode === 'carrier')
    ) {
      <mat-hint>No associated NPNs found</mat-hint>
    }
    @if (currentChip()) {
      <button
        matSuffix
        matIconButton
        aria-label="Clear"
        color="warn"
        type="button"
        matTooltip="Clear NPN Search"
        (click)="clearNpnSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>

  <span class="rb-range-picker-container">
    <mat-form-field class="me-2">
      <mat-label>Issue Date Range</mat-label>
      <mat-select
        [formControl]="presetRangeControl"
        (selectionChange)="rangeSelection($event)"
      >
        @for (opt of floatingRangeOptions; track opt.value) {
          <mat-option value="{{ opt.value }}">
            {{ opt.display }}
          </mat-option>
        }
      </mat-select>
      @if (presetRangeControl.value) {
        <button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          color="warn"
          type="button"
          matTooltip="Clear Filter"
          (click)="clearDateField($event)"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    <mat-form-field
      class="mr-2 preset-date-picker"
      [ngClass]="{
        visible: presetRangeControl.value === 'custom',
      }"
    >
      <mat-label>Issue Date Range</mat-label>
      <mat-date-range-input [rangePicker]="pickerField" [min]="minDate">
        <input
          #startDatePicker
          matStartDate
          placeholder="After"
          [(ngModel)]="dateRange.start"
          (dateChange)="dateChange($event, 'start')"
        />
        <input
          #endDatePicker
          matEndDate
          placeholder="Before"
          [(ngModel)]="dateRange.end"
          (dateChange)="dateChange($event, 'end')"
        />
      </mat-date-range-input>
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        color="warn"
        type="button"
        (click)="clearDateField($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle matIconSuffix [for]="pickerField" />
      <mat-date-range-picker #pickerField />
    </mat-form-field>
  </span>

  <button
    matButton="elevated"
    color="primary"
    class="search-button ml-2"
    [disabled]="
      !filtersUpdated ||
      (viewMode === 'carrier' && !dateRange.start && !dateRange.end)
    "
    (click)="triggerSearch()"
  >
    <mat-icon class="mr-2">search</mat-icon>
    Update Filters
  </button>
</div>

<div class="w-100 mb-1 grid-controls">
  <button mat-button color="primary" (click)="resetFilters()">
    <mat-icon class="me-2">replay</mat-icon>
    Clear Filters
  </button>
</div>
